import { compose, identity, path, merge } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';

export default class EditLicenseRequestForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      licenseNum: 1
    };
  }
  render() {
    return (
      <form>
        {this.renderInput('Licencias a agregar', 'licenseRequest')}
      </form>
    );
  }
  renderInput(label, id) {
    const input = <input type='text' value={this.props.value[id]} onChange={this.handleChange(id, path(['target', 'value']))} />;
    return this.renderRow(label, input);
  }
  renderRow(label, input) {
    return (
      <div className='row form-group'>
        <label className='col-xs-3 col-xs-offset-2' style={{ textAlign: 'right' }}>{label}</label>
        <div className='col-xs-6'>
          {input}
        </div>
      </div>
    );
  }
  handleChange(field, getValue) {
    return (event) => {
      const value = getValue(event);
      this.props.onChange(merge(this.props.value, { [field]: value }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/licenses/EditLicenseRequestForm.jsx